import { useLaunchDarkly } from '@getaccept/lib-shared/src/launch-darkly/launch-darkly.composable';
import { AnalyticsUserTrait } from '@getaccept/lib-shared/src/types/analytics';
import { LaunchDarklyContextKind } from '@getaccept/lib-shared/src/launch-darkly/types/enums/launch-darkly-context-kind';
import { basicLogger } from 'launchdarkly-js-client-sdk';
import { useSessionStore } from './session/store/session.store';

export const loadLaunchDarkly = () => {
  const sessionStore = useSessionStore();
  const { initialize } = useLaunchDarkly();
  initialize(
    import.meta.env.VUE_APP_LAUNCHDARKLY_KEY,
    {
      kind: LaunchDarklyContextKind.User,
      key: sessionStore.session.user_hash,
      [AnalyticsUserTrait.AppMode]: sessionStore.session.app_mode,
      [AnalyticsUserTrait.CompanyId]: sessionStore.session.entity_hash,
      [AnalyticsUserTrait.Language]: sessionStore.session.language,
      [AnalyticsUserTrait.Plan]: sessionStore.session.plan,
      [AnalyticsUserTrait.Role]: sessionStore.session.user_role,
      [AnalyticsUserTrait.RegistrationSource]: sessionStore.session.registration_source,
      [AnalyticsUserTrait.RegistrationCampaign]: sessionStore.session.registration_campaign,
      [AnalyticsUserTrait.CompanyName]: sessionStore.session.entity_name,
      [AnalyticsUserTrait.CompanyPlan]: sessionStore.session.plan,
      [AnalyticsUserTrait.TeamCount]: sessionStore.session.team_count,
      [AnalyticsUserTrait.CreatedAt]: sessionStore.session.user_created_at,
    },
    {
      bootstrap: 'localStorage',
      logger: basicLogger({ level: 'error' }),
    }
  );
};
